import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import questions from "../data/questions.json";
import SinglePageTest from "./SinglePageTest";
import { TESTS } from "../utils/constants";
import { clearTestStorage } from "../utils/common";

const TestPage = () => {
  const location = useLocation();
  const path = location.pathname;
  const testId = path.startsWith("/") ? path.slice(1) : sessionStorage.getItem('test-id');
  
  const navigate = useNavigate();
  const test = questions[testId];
  sessionStorage.setItem('test-id', testId)
  const [responses, setResponses] = useState({});
  const [hasTest, setHasTest] = useState(false);

  useEffect(() => {
    const hasTestId = TESTS.find((it) => it === testId) ? true : false
    if (!hasTestId/*  || testId !== CONSTANTS.SSCERID *//* FOR TESTING */) {
      clearTestStorage();
      navigate('/');
    }
    setHasTest(hasTestId)
  }, [])


  return hasTest && <SinglePageTest
    test={test}
    testId={testId}
    responses={responses}
    setResponses={setResponses}
  />
}

export default TestPage;